import { Checkbox } from "@/atoms-react/input-checkbox/index.react.tsx";
import Loader from "@/atoms-react/loader/Loader.react.tsx";
import { Base } from "@/atoms-react/text/Text.react.tsx";
import type { bronzeCategories } from "@/features/user/quiz/types";
import { usei18n } from "@/features/utils/hooks/use-i18n";

export const SourceIncomes = ({
  setFormResponseSI,
  sourceIncomeItems,
  sourceIncomes,
  isLoadingSourcesIncome
}: {
  setFormResponseSI: (sourceIncome: bronzeCategories, isChecked: boolean) => void;
  sourceIncomeItems: bronzeCategories[];
  sourceIncomes: string[];
  isLoadingSourcesIncome: boolean;
}) => {
  const { getLanguage } = usei18n();

  const handleCheckboxChange = (sourceIncome: bronzeCategories, isChecked: boolean) => {
    setFormResponseSI(sourceIncome, isChecked);
  };
  return (
    <>
      {isLoadingSourcesIncome && (
        <div className="mt-4 mb-4 flex flex-1 items-center justify-center">
          <Loader className="text-gray-500" />
        </div>
      )}

      {!isLoadingSourcesIncome && (
        <div className="flex w-full flex-col">
          <div className="my-4 mt-4 grid grid-cols-1 gap-2 md:grid-cols-2">
            {sourceIncomeItems &&
              sourceIncomeItems.map((c) => (
                <Checkbox
                  key={c.code}
                  value={
                    sourceIncomes &&
                    sourceIncomes.some((income) => {
                      return Number(income) === Number(c.code);
                    })
                  }
                  onChange={(value) => handleCheckboxChange(c, value)}
                >
                  <Base className="mb-1 cursor-pointer">
                    {getLanguage() === "fr" ? c.name : c.english_name}
                  </Base>
                </Checkbox>
              ))}
          </div>
        </div>
      )}
    </>
  );
};
